var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppliedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MDI_clock-check-outline",
    "data-name": "MDI / clock-check-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 16.667,
    viewBox: "0 0 16.667 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.667,
    height: 16.667,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15.667,
    height: 15.667,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_clock-check-outline",
    "data-name": "Path / clock-check-outline",
    d: "M16.931,12.417l-3.472,3.472-2.431-2.431,1.042-1.042,1.389,1.389,2.431-2.431,1.042,1.042M9.708,14.431a2.849,2.849,0,0,1-.764.069A5.556,5.556,0,1,1,14.5,8.944a2.849,2.849,0,0,1-.069.764,4.189,4.189,0,0,1,1.319.417,6.842,6.842,0,0,0,.139-1.181,6.944,6.944,0,1,0-6.944,6.944,6.116,6.116,0,0,0,1.181-.139,3.686,3.686,0,0,1-.417-1.319M11.444,10.4,9.292,9.153V5.472H8.25V9.639L10.681,11.1A3.64,3.64,0,0,1,11.444,10.4Z",
    transform: "translate(-1.306 -0.786)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliedIcon);
export default __webpack_public_path__ + "static/media/appliedIcon.2a826d5343bbdc642711b331742d9ec4.svg";
export { ForwardRef as ReactComponent };